'use strict';

function isValidInputType(cardNumber) {
  return typeof cardNumber === 'string' || cardNumber instanceof String;
}

module.exports = isValidInputType;



//////////////////
// WEBPACK FOOTER
// ./~/credit-card-type/lib/is-valid-input-type.js
// module id = 1149
// module chunks = 1